import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["checkbox", "container"]

  connect() {
    this.toggleContainer()
    this.setupFormSubmission()
    console.log("ICS Attachment Controller connected for block:", this.element.dataset.blockId)
  }

  toggle() {
    this.toggleContainer()
  }

  toggleContainer() {
    if (this.hasCheckboxTarget && this.hasContainerTarget) {
      if (this.checkboxTarget.checked) {
        this.containerTarget.style.display = "block"
        // Ensure the select field is enabled when shown
        const select = this.containerTarget.querySelector("select")
        if (select) {
          select.disabled = false
          // Reinitialize slim-select if it exists
          if (select.slimSelectInstance) {
            select.slimSelectInstance.setSelected(select.value)
          }
          console.log("ICS datetime field container shown, select enabled:", select.name)
        }
      } else {
        this.containerTarget.style.display = "none"
        // Clear the datetime field selection when unchecked
        const select = this.containerTarget.querySelector("select")
        if (select) {
          select.value = ""
          // Update slim-select if it exists
          if (select.slimSelectInstance) {
            select.slimSelectInstance.setSelected("")
          }
          console.log("ICS datetime field container hidden, select cleared:", select.name)
        }
      }
    }
  }

  setupFormSubmission() {
    // Find the form that contains this ICS attachment controller
    const form = this.element.closest('form')
    if (form) {
      // Add event listener for form submission to ensure slim-select values are synced
      form.addEventListener('submit', (event) => {
        console.log("Form submission detected, syncing slim-select values")
        this.syncSlimSelectValues()
      })
      
      // Also listen for form submit button clicks
      const submitButtons = form.querySelectorAll('input[type="submit"], button[type="submit"]')
      submitButtons.forEach(button => {
        button.addEventListener('click', (event) => {
          console.log("Submit button clicked, syncing slim-select values")
          this.syncSlimSelectValues()
        })
      })
    }
  }

  syncSlimSelectValues() {
    // Find all slim-select elements within this controller and sync their values
    const selectElements = this.element.querySelectorAll('select.slim-select')
    selectElements.forEach(select => {
      if (select.slimSelectInstance) {
        // Get the selected value from slim-select
        const selectedValue = select.slimSelectInstance.getSelected()
        // Sync it back to the original select element
        if (selectedValue && selectedValue.length > 0) {
          select.value = selectedValue[0]
        } else {
          select.value = ""
        }
        console.log(`Synced slim-select value for ${select.name}: ${select.value}`)
      } else {
        console.log(`No slim-select instance found for ${select.name}`)
      }
    })
  }
}
